import { Box, Text } from '@nimbus-ds/components';
import { CurrencyType } from '@tiendanube/common';
import { CurrencyPrice } from 'commons/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders/useTranslationOrders';
import { ProductInterface } from '../../types';

interface VariantStockPriceProps {
  variant: ProductInterface<false>;
  showPrice: boolean;
  currencyDisplay?: CurrencyType;
}

function VariantStockPrice({
  variant,
  showPrice,
  currencyDisplay,
}: Readonly<VariantStockPriceProps>) {
  const t = useTranslationOrders();

  const getStockTextOption = () => {
    if (variant.stock === null) {
      return 'infiniteStock';
    }
    if (variant.stock > 0) {
      return 'inStock';
    }
    return 'outOfStock';
  };

  const justifyContent = showPrice ? 'space-between' : 'flex-end';

  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent={justifyContent}
      alignItems="flex-start"
      flex="1"
    >
      <Text
        color={variant.stock === 0 ? 'danger-interactive' : 'neutral-textLow'}
      >
        {t(`productSearcher.${getStockTextOption()}`, {
          count: variant.stock ?? 0,
        })}
      </Text>
      {showPrice && (
        <CurrencyPrice
          price={variant.price}
          currency={currencyDisplay}
          bold
          appearance="light"
        />
      )}
    </Box>
  );
}

export default VariantStockPrice;
